var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.42969 5.3501H9.42969",
    stroke: "#FB8500",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2627 6.3501H17.6607C15.8757 6.3501 14.4297 7.6931 14.4297 9.3501C14.4297 11.0071 15.8767 12.3501 17.6597 12.3501H20.2627C20.3467 12.3501 20.3877 12.3501 20.4227 12.3481C20.9627 12.3151 21.3927 11.9161 21.4277 11.4151C21.4297 11.3831 21.4297 11.3441 21.4297 11.2671V7.4331C21.4297 7.3561 21.4297 7.3171 21.4277 7.2851C21.3917 6.7841 20.9627 6.3851 20.4227 6.3521C20.3887 6.3501 20.3467 6.3501 20.2627 6.3501Z",
    stroke: "#FB8500",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3947 6.3501C20.3167 4.4781 20.0667 3.3301 19.2577 2.5221C18.0867 1.3501 16.2007 1.3501 12.4297 1.3501H9.42969C5.65869 1.3501 3.77269 1.3501 2.60169 2.5221C1.42969 3.6931 1.42969 5.5791 1.42969 9.3501C1.42969 13.1211 1.42969 15.0071 2.60169 16.1781C3.77269 17.3501 5.65869 17.3501 9.42969 17.3501H12.4297C16.2007 17.3501 18.0867 17.3501 19.2577 16.1781C20.0667 15.3701 20.3177 14.2221 20.3947 12.3501",
    stroke: "#FB8500",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4209 9.3501H17.4309",
    stroke: "#FB8500",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.30d6e8d8982d2cbe3916d9db1a2c07fa.svg";
export { ForwardRef as ReactComponent };